import React from 'react';
import { formatNumber } from '../../domain/utils/Format/formatNumber.js';

/**
 * MetricItem Sub-Component
 * Displays a single metric with label and formatted count
 */
const MetricItem = ({ label, count }) => (
  <div className="flex flex-col items-center justify-center p-3 sm:p-4 bg-white/5 rounded-lg border border-white/10 hover:border-cyan-400/30 transition-all">
    <p className="text-gray-400 text-xs sm:text-sm font-bold uppercase tracking-wider mb-2">
      {label}
    </p>
    <p className="text-white text-2xl sm:text-3xl font-bold">
      {formatNumber(count)}
    </p>
  </div>
);

/**
 * CountsCard Component
 * Displays engagement metrics (views, shares, favorites) in a card layout
 * 
 * @param {Object} props
 * @param {Object} props.counts - Engagement metrics object
 * @param {number} props.counts.views - Total profile views
 * @param {number} props.counts.shares - Total profile shares
 * @param {number} props.counts.favorites - Total profile favorites
 */
const CountsCard = ({ counts = { views: 0, shares: 0, favorites: 0 } }) => {
  return (
    <div className="bg-gradient-to-br from-white/10 to-white/5 rounded-2xl shadow-2xl p-4 sm:p-6 backdrop-blur-xl border border-white/20 hover:border-cyan-400/50 transition-all duration-500">
      <h2 className="text-xl sm:text-2xl font-bold bg-gradient-to-r from-white to-cyan-200 bg-clip-text text-transparent mb-6">
        Engagement
      </h2>

      <div className="grid grid-cols-3 gap-3 sm:gap-4">
        <MetricItem label="Views" count={counts.views} />
        <MetricItem label="Shares" count={counts.shares} />
        <MetricItem label="Favorites" count={counts.favorites} />
      </div>
    </div>
  );
};

export default CountsCard;
